// sly.js requires the document to be ready
$(function() {
	(function() {
		var
			// elements
			$frame,
			$slides,
			$wrapper,
			$carousel,
			// props
			initial_width,
			current,
			speed_in = 1,
			speed_out = 1,
			mobile = false,
			scale_factor = 1;

		$frame = $('#horizontal-gallery');
		$slides = $('ul.slides li');
		$wrapper = $('.wrapper');
		$carousel = $('.slides');

		$frame.imagesLoaded(function() {

			// prep
			$slides.find('span.caption').hide();
			var tmp = $($slides[0]).find('span.caption');
			if (tmp.length) {
				$(tmp).show();
			}

			$slides.find('span.expander').hide();
			var expander = $($slides[0]).find('span.expander');
			if (expander.length) {
				$(expander).show();
			}

			// initilise the carousel
			$frame.sly({
				'horizontal': 1,
				'itemNav': 'forceCentered',
				'smart': 1,
				'activateMiddle': 1,
				'activateOn': 'click',
				'mouseDragging': 1,
				'touchDragging': 1,
				'releaseSwing': 1,
				'startAt': 0,
				'scrollSource': null,
				'scrollBy': 0,
				'speed': 300,
				'elasticBounds': 1,
				'easing': 'easeOutExpo',
				'dragHandle': 1,
				'dynamicHandle': 1,
				'clickBar': 1,

				// buttons
				'prev': $wrapper.find('.prev'),
				'next': $wrapper.find('.next')
			});

			// get the initial carousel width
			initial_width = $carousel.outerWidth(true);

			// if (WS.JSMedia.run([['(max-width: 960px)']])) {
			// 	scale_factor = 1.65;
			// }

			if (WS.JSMedia.run([['(max-width: 960px)']])) {
				mobile = true;
			}

			/*!
			 * on slide "change"
			 * - reset any properties we mutated
			 */
			$frame.sly('on', 'change', function(event, slide) {
				if (current) {
					// reset the size of the current slide
					current.css({
						'height': 280,
						'width': current.prop('thumb_width')
					});

					// set the carousel width to initial value
					$carousel.css({
						'width': initial_width
					}).prop('active', false);

					current.parent().removeClass('open');
				}
			});

			/*!
			 * on slide "active"
			 * - hide all captions and show the current
			 */
			$frame.sly('on', 'active', function(event, slide) {
				// hide all captions and expanders ...
				$slides.find('span.caption').hide();
				$slides.find('span.expander').hide();

				// ... and show current if we have one
				var tmp, img, imgObj, expander;

				tmp = $($slides[slide]).find('span.caption');
				img = $($slides[slide]).find('img');

				expander = $($slides[slide]).find('span.expander');
				$(expander).show();

				imgObj = new Image();
				imgObj.onload = function() {
					if (tmp.length) {
						$(tmp).show();
					}
				};
				imgObj.src = $(img).attr('src');
			});

			/*!
			 * on slide "click"
			 * - scale the image and set relevant properties to allow this
			 */
			$slides.each(function(index, slide) {
				var tmpImg = $(slide).find('img'),
					tmpWidth = tmpImg.outerWidth(true);

				tmpImg
					.css('width', tmpWidth)
					.prop('thumb_width', tmpWidth);

				// click event for each slide
				$(slide).on('click', function(event) {
					var tmp = $(this),
						current = $(tmp.find('img'));

					if (mobile) {
						return;
					}

					if (tmp.hasClass('active')) {
						if (current && current.prop('active')) {
							// get the image dimensions
							img = new Image();
							img.onload = function() {
								// reset the size of the current slide
								current.animate({
									'height': 280,
									'width': current.prop('thumb_width')
								}, 240, function() {
									// set the carousel width to initial value
									$carousel.css({
										'width': initial_width
									});
								}).prop('active', false);
								current.parent().removeClass('open');
							};
							img.src = current.attr('src');
						} else {
							// ... get a reference to current and set the width
							current = $(tmp.find('img'));

							// get the image dimensions
							img = new Image();
							img.onload = function() {
								// set the carousel width ...
								$carousel.css({
									'width': (initial_width + img.width / scale_factor)
								});

								current.prop('real_height', img.height / scale_factor);

								// scale the image
								current.css({
									'height': img.height / scale_factor,
									'width': img.width / scale_factor
								}).prop('active', true);
								current.parent().addClass('open');
							};
							img.src = current.attr('src');
						}

					}
				});
			});

		});

	})(); // closure
});